/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useState } from "react";
import { FaArrowRight, FaArrowLeft, FaTrash } from "react-icons/fa";

const InboxAdmin = () => {
  const [checkedItems, setCheckedItems] = useState([]);
  const [messages, setMessages] = useState([
    "Order 01#J Rejected the Quotation - You are not impressed by the offer",
    "Order 02#J Rejected the Quotation - You are not impressed by the offer",
    "Order 03#J Payment Completed",
    "Order 04#J Rejected the Quotation - You are not impressed by the offer",
    "Order 05#J Payment Completed",
    "Order 06#J Rejected the Quotation - You are not impressed by the offer",
    "Order 07#J Payment Completed",
    "Order 08#J Rejected the Quotation - You are not impressed by the offer",
    "Order 09#J Payment Completed",
    "Order 10#J Payment Completed"
  ]);

  const [isCheckboxVisible, setIsCheckboxVisible] = useState(false);

  const handleCheckboxChange = (index) => {
    setCheckedItems((prev) => {
      const newCheckedItems = [...prev];
      if (newCheckedItems.includes(index)) {
        return newCheckedItems.filter((item) => item !== index);
      } else {
        newCheckedItems.push(index);
      }
      return newCheckedItems;
    });
  };

  const handleSelectToggle = () => {
    setIsCheckboxVisible(!isCheckboxVisible);
    if (!isCheckboxVisible) {
      setCheckedItems([0]); // Select the first item when the checkbox becomes visible
    } else {
      setCheckedItems([]); // Deselect all items when hiding checkboxes
    }
  };

  const handleDeleteAll = () => {
    setMessages([]);
    setCheckedItems([]);
  };

  const handleDeleteSingle = (index) => {
    setMessages((prev) => prev.filter((_, msgIndex) => msgIndex !== index));
    setCheckedItems((prev) => prev.filter((item) => item !== index));
  };

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto pt-1 lg:pt-4 pb-12">
        <div className="w-full mx-auto py-8 shadow-xl bg-white rounded-lg">
          <h2 className="text-2xl text-navBg font-semibold px-6 py-4">
            Inbox Message
          </h2>
          <div>
            <div className="font-semibold px-6 text-xl py-4">
              {messages.map((message, index) => (
                <div key={index} className="flex items-center mb-6">
                  {isCheckboxVisible && (
                    <input
                      type="checkbox"
                      className="mr-3"
                      checked={checkedItems.includes(index)}
                      onChange={() => handleCheckboxChange(index)}
                    />
                  )}
                  <h1 className="flex-grow">{message}</h1>
                  {checkedItems.includes(index) && (
                    <FaTrash
                      className="text-black cursor-pointer hover:text-gray-700"
                      onClick={() => handleDeleteSingle(index)}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-between items-center mx-4 py-6">
            <div className="text-white">
              <button
                className="bg-navBg h-10 w-40 rounded-lg font-semibold"
                onClick={handleSelectToggle}
              >
                {isCheckboxVisible ? "Unselect" : "Select"}
              </button>
              {isCheckboxVisible && (
                <button
                  className="bg-navBg h-10 w-40 ml-10 rounded-lg font-semibold"
                  onClick={handleDeleteAll}
                >
                  Delete All
                </button>
              )}
            </div>
            <div className="flex items-center gap-2">
              <div className="flex justify-center items-center w-[40px] h-[40px] cursor-pointer rounded-full bg-gray-200 hover:bg-gray-500 hover:text-white">
                <FaArrowLeft />
              </div>
              <div className="flex justify-center items-center w-[40px] h-[40px] cursor-pointer rounded-full bg-gray-200 hover:bg-gray-500 hover:text-white">
                <FaArrowRight />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InboxAdmin;
